import React from 'react'
import PropTypes from 'prop-types'
import { Box, Title, Level, Text, Rating, List, Link } from '@deseretbook/react-ui'
import { ClickableContent } from '../../core'

/**
 * Product overview section which displays the title, rating, runtime, descriptions
 *
 * @returns {function} - React Component
 */
export const Overview = ({ product = {}, isDark = false, updateActiveTab }) => {
  const productProperties = product.productProperties.reduce((acc, cur) => {
    acc[cur.property.presentation] = cur.value

    return acc
  }, {})

  return (
    <React.Fragment>
      <Title
        title={product.name}
        size={1}
        {...(isDark && { titleProps: { style: { color: isDark ? 'white' : 'black' } } })}
      />
      <Level>
        <Level.Left>
          <Level.Item>
            <Text {...(isDark && { color: 'light' })}>{productProperties['Run Time']}</Text>
          </Level.Item>

          <Level.Item>
            <Text {...(isDark && { color: 'light' })}>{productProperties['MPAA Rating']}</Text>
          </Level.Item>
        </Level.Left>
      </Level>
      {product.reviewsCount > 0 ? (
        <Box paddingBottom={1}>
          <ClickableContent
            onClick={() => updateActiveTab(0)}
            {...(isDark && { color: 'dark', shade: 'light' })}
          >
            <Level>
              <Level.Left>
                <Level.Item>
                  <Rating average={product.avgRating} />
                </Level.Item>
                <Level.Item>{`(${product.reviewsCount})`}</Level.Item>
              </Level.Left>
            </Level>
          </ClickableContent>
        </Box>
      ) : (
        <Box paddingBottom={1}>
          <List type="horizontal">
            <List.Item>
              <Text>No Reviews</Text>
            </List.Item>
            <List.Item>
              <Link href={`/products/${product.id}/reviews/new`}>Be the first</Link>
            </List.Item>
          </List>
        </Box>
      )}

      <Text {...(isDark && { color: 'light' })}>{productProperties.Description}</Text>
    </React.Fragment>
  )
}

Overview.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    avgRating: PropTypes.number,
    reviewsCount: PropTypes.number,
    id: PropTypes.number,
    productProperties: PropTypes.arrayOf(PropTypes.object),
  }),
  isDark: PropTypes.bool,
  updateActiveTab: PropTypes.func,
  lesson: PropTypes.shape({
    description: PropTypes.string,
    duration: PropTypes.number,
    title: PropTypes.string,
  }),
}
